module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/aH8Y8w/images/cover.jpg?1684515200441",
      "alt": "This image is the cover for the book A Good Vintage"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("A Good Vintage\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("Luke Scherer has turned bad romance into an art. When he catches his latest deadbeat boyfriend selling Luke’s belongings—and his own body—to cover his debts, Luke decides he needs a vacation. He just doesn’t expect his Napa Valley retreat to be a step into his past.")]), _vm._v(" "), _c('p', [_vm._v("Eight years ago Mal Kuijpers was grieving his wife while his vineyard floundered. Hiring Luke for the summer put the business back on track and a smile back on Mal’s face.")]), _vm._v(" "), _c('p', [_vm._v("Nineteen-year-old Luke had just gotten out from under his father’s thumb and started saving for his education, his last screw-you to his old man. Then he made the mistake of falling for his boss, his dad caught up with him, and Luke panicked—and fled.")]), _vm._v(" "), _c('p', [_vm._v("Now they have another chance. Mal has his own share of closet skeletons, including a family he doesn’t talk to and a dead wife he sometimes does, and he’s gone without romance for years. He works hard to convince Luke he’s worth more than a casual fling and asks for nothing in return, but Luke needs a relationship of equals. If Mal can believe in himself and Luke can believe in love, two hot summers might yield a lifelong reward.")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Ashlyn Kane\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0